import React, { useMemo } from "react";
import { sanitizeHtml } from "../../lib/richText";

export interface RichTextContentProps {
  /** What a `RichTextEditor` handed back. */
  html: string;
  /**
   * A smaller base size, for a preview standing beside the editor that wrote
   * it - the client's page at a glance, rather than at full size.
   */
  compact?: boolean;
  className?: string;
}

/**
 * Formatted text drawn read-only, the way a client will see it.
 *
 * The one place `dangerouslySetInnerHTML` is used for text a person typed,
 * and it is always through `sanitizeHtml` first - so a paste that brought a
 * script along cannot run here, and by the same token cannot run on the page
 * a client opens. The rules it is drawn under are the editor's own, so the
 * two never disagree about what a heading or a list looks like.
 */
const RichTextContent: React.FC<RichTextContentProps> = ({
  html,
  compact = false,
  className = "",
}) => {
  const safe = useMemo(() => sanitizeHtml(html), [html]);

  return (
    <div
      className={`rich-text ${compact ? "rich-text--compact" : ""} ${className}`}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
};

export default RichTextContent;
